import * as generated from '@/routes/org';
import * as login from '@/routes/org/login';
import * as enrollment from '@/routes/org/enroll';
import * as challenge from '@/routes/org/challenge';
import * as recovery from '@/routes/org/recovery';
import { relative } from './relative';
export const dashboard = relative(generated.dashboard);
export const activity = relative(generated.activity);
export const logout = relative(generated.logout);
export const loginPage = relative(generated.login);
export const signIn = relative(login.store);
export const enrollConfirm = relative(enrollment.confirm);
export const verifyChallenge = relative(challenge.verify);
export const acknowledgeRecovery = relative(recovery.acknowledge);
